import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { IBodyDeleteSubstitutionPartParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodySubstitutionPart/deleteBodySubstitutionPartQueryOption.type';
import { deleteBodySubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodySubstitutionPart/deleteBodySubstitutionPartQueryFunction';

export const deleteBodySubstitutionPartQueryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IBodyDeleteSubstitutionPartParamsType
> => ({
  mutationKey: ['deleteBodySubstitutionPartQueryOption'],
  mutationFn: (params: IBodyDeleteSubstitutionPartParamsType) =>
    deleteBodySubstitutionPartQueryFunction(params),
});
